import axios from "axios";

const getDefaultState = () => {
  return {
    loading: "empty",
    profile: {
      id: null,
      last_pay_date: null,
      card: {
        card_expiry_date: "",
        card_number: "",
      },
      pay_plan: null,
      next_payment: null,
    },
    payments: [],
  };
};
const state = getDefaultState;

const getters = {
  getPaymentsLoadingState: (state) => {
    return state.loading;
  },
  getPaymentProfile: (state) => {
    return state.profile;
  },
  getPaymentsHistory: (state) => {
    return state.payments;
  },
};

const mutations = {
  resetPayState(state) {
    Object.assign(state, getDefaultState());
  },
  setProfileInfo: (state, payProfileData) => {
    state.profile.id = payProfileData.id;
    state.profile.last_pay_date = payProfileData.last_pay_date;
    state.profile.card = {
      card_number: payProfileData.card_number,
      card_expiry_date: payProfileData.card_expiry_date,
    };
    state.profile.pay_plan = payProfileData.pay_plan;
    state.profile.next_payment = payProfileData.planned;
  },
  setPaymentsLoading: (state, bool) => {
    state.loading = bool;
  },
  setNextPayment: (state, payment) => {
    state.profile.next_payment = payment;
  },
  setPayPlan: (state, payPlan) => {
    state.profile.pay_plan = payPlan;
  },
  setPaymentsHistory: (state, payments) => {
    state.payments = payments;
  },
};
const actions = {
  updateNextPayment({ commit }, payment) {
    commit("setNextPayment", payment);
  },
  resetPaymentsState({ commit }) {
    commit("resetPayState");
  },
  async loadPayProfile({ commit }) {
    commit("setPaymentsLoading", true);
    try {
      let { data } = await axios.get("user-payment-info");
      commit("setProfileInfo", data.data);
      commit("setPaymentsHistory", data.data.payments);
      commit("setPaymentsLoading", false);
    } catch (e) {
      commit("setPaymentsLoading", "empty");
      throw e;
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
